<script lang="ts">
	import { slideIn } from '$lib/actions/slideIn';
	import Quote from '$lib/icons/quote.svelte';
	import Image from '$lib/storyblok/components/image.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { SbImage, SbLink } from '$lib/storyblok/types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			image: SbImage;
			outlet_logo: SbImage;
			quote: string;
			name: string;
			job_title?: string;
			link: SbLink;
		}>['content'];
		delay?: number;
	}

	let { content, delay = 100 }: Props = $props();
</script>

<a
	use:editable={content}
	use:slideIn={{ delay }}
	href={getSbUrl(content.link)}
	target={content.link?.target}
	class="relative block min-h-[238px] overflow-hidden rounded-xl opacity-[0.01] lg:min-h-[372px]"
>
	<Image
		wrapperClass="absolute inset-0"
		class="z-0 h-full w-full object-cover"
		src={content.image?.filename}
		alt={content.image?.alt}
		title={content.image?.title}
		height={238}
		sizes={{ 1024: { height: 550 } }}
	/>
	<Image
		class="absolute left-3 top-3 z-10 h-7 lg:left-5 lg:top-5"
		src={content.outlet_logo?.filename}
		alt={content.outlet_logo?.alt}
		title={content.outlet_logo?.title}
		height={28}
	/>

	<div class="overlay absolute inset-x-0 bottom-0 z-20 p-3 text-white lg:p-5">
		<Quote class="mb-2 h-3 w-3" />

		<p
			class="mb-3 text-[24px]/[108%] font-semibold tracking-[-.24px] lg:text-[24px]/[110%] lg:tracking-[-.24px]"
		>
			{content.quote}
		</p>

		<p class="text-[18px]/[normal] tracking-[-.18px]">
			{content.name}
		</p>
		{#if content.job_title && content.job_title.length > 0}
			<p class="text-[12px]/[112%] max-lg:tracking-[.12px] lg:text-[14px]/[160%]">
				{content.job_title}
			</p>
		{/if}
	</div>
</a>

<style>
	div.overlay {
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
	}
</style>
